// @ts-strict-ignore
import React, { type CSSProperties, useEffect, useState } from 'react';

import { useAuth } from '../hooks/useAuth';
import { theme } from '../style';

import BackupWarning from './BackupWarning';
import { Link } from './common/Link';
import { Text } from './common/Text';
import { View } from './common/View';

type StorageWarningProps = {};

const viewStyle: CSSProperties = {
  minHeight: 50,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  gap: 5,
  padding: 10,
};

function StorageWarning({}: StorageWarningProps) {
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const { billingStatus } = useAuth();

  useEffect(() => {
    if (billingStatus?.isActive) {
      setShowWarning(false);
    } else {
      (async () => {
        const permission = await navigator.permissions.query({
          name: 'persistent-storage',
        });
        if (
          permission.state !== 'granted' &&
          navigator.userAgent.indexOf('Firefox') !== -1
        ) {
          setShowWarning(true);
        }
      })();
    }
  }, [billingStatus?.isActive]);

  return showWarning && !billingStatus?.isActive ? (
    <View style={{ ...viewStyle, backgroundColor: theme.reportsRed }}>
      <Text>
        <strong>Good Steward</strong> stores all your data locally on your
        device, but Firefox may purge any site data, including your budget data
        without warning. To prevent budget data loss, please click{' '}
        <Link
          variant="text"
          onClick={onPermissionRequest}
          style={{ textDecorationLine: 'underline', color: 'white' }}
        >
          here
        </Link>{' '}
        to allow Good Steward to persist your data locally.
      </Text>
    </View>
  ) : (
    <BackupWarning />
  );

  async function onPermissionRequest() {
    if (navigator.storage && navigator.storage.persist) {
      navigator.storage.persist().then(persistent => {
        if (persistent) {
          setShowWarning(false);
          console.log(
            'Storage will not be cleared except by explicit user action',
          );
        } else {
          console.log(
            'Storage may be cleared by the UA under storage pressure.',
          );
        }
      });
    }
  }
}

export default StorageWarning;
